import * as React from '../../../../node_modules/react'
import { useEffect, useState } from '../../../../node_modules/react'
import { ActionButton, DialogFooter, IDialogProps, PrimaryButton, TextField } from '@fluentui/react'
import { FileAction, IOverviewItemDto } from '../../../config/fileConfig'
import LegacyBaseDialog from '../LegacyBaseDialog'
import useAxios from '../../../hooks/useAxios'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from '../../../reducers'
import { IFileListSettings } from '../../List/File/FileList'
import { DataPromise } from '../../../context/AxiosContext'
import { parseFileSettingsToParams } from '../../../pages/File/FileOverview'

type Props = IDialogProps & {
    id: string
    name: string
}

export default function CopyFileDialog(props: Props) {
    const axios = useAxios()
    const dispatch = useDispatch()
    const history = useHistory()
    const [name, setName] = useState<string>('')
    const [description, setDescription] = useState<string>('')
    const { settings } = useSelector<Store, DataPromise<IOverviewItemDto[], IFileListSettings>>(
        state => state.files.overview,
    )

    useEffect(() => {
        const name = props.name || ''
        const end = name.indexOf('/')
        setName(end >= 0 ? name.substring(0, end + 2) : `${name} / `)
    }, [props.name])

    return (
        <LegacyBaseDialog {...props} dialogContentProps={{ title: 'Dossier kopiëren' }}>
            <TextField
                label={'Dossiernaam'}
                value={name}
                onChange={(_, newValue?: string) => setName(newValue)}
                autoFocus
            />
            <TextField
                label={'Dossieromschrijving'}
                value={description}
                onChange={(_, newValue?: string) => setDescription(newValue)}
                multiline
                autoAdjustHeight
                rows={3}
            />
            <DialogFooter>
                <PrimaryButton
                    text="Kopie maken"
                    disabled={!name}
                    onClick={() => {
                        axios.post<string>(`/file/copy/${props.id}`, { name, description }).then(response => {
                            dispatch({
                                type: FileAction.GetOverview,
                                payload: axios.get('/file', { params: parseFileSettingsToParams(settings) }),
                            })

                            history.push(`/file/${response.data}`)
                        })
                        props.onDismiss()
                    }}
                />
                <ActionButton text="Annuleren" onClick={props.onDismiss} />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
